import EmailService from "../../services/email-service"
import { makeEmailResource } from "../resources/email-resource-factory"

export const makeEmailService = (): EmailService => {
    return new EmailService(makeEmailResource())
}
